import React from 'react';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl/dist';
import styled from 'styled-components';

import Button from 'react-bootstrap/Button';

// styles

const StyledLink = styled(Link)`
    width: 15vw;
    font-size: 2rem;
    font-weight: 800;
`;

// props

export interface BackToResultsProps {
    to: any;
}

function BackToResults(props: BackToResultsProps) {

    const { to } = props;

    return (
        <StyledLink to={to}><FormattedMessage id='common.back_to_results' /></StyledLink>
    )
}

export default BackToResults;